var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('UiPageTitle',{attrs:{"title":"Добавление сотрудника","back-link":{ name: 'managers' }}}),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('ManagerInfo')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }